export const isAST_Function = (node) => {
    return (typeof (node === null || node === void 0 ? void 0 : node.type) === 'string' && Array.isArray(node === null || node === void 0 ? void 0 : node.args));
};
